import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import Landing from 'containers/Landing/Landing'

import { LEADERBOARD, CHALLENGES } from 'urls'

export class StrongholdWrapper extends React.PureComponent {
    static propTypes = {
        isNonClanUser: PropTypes.bool,
        canVisitLocation: PropTypes.bool,
    }

    render() {
        if (this.props.isNonClanUser) {
            if (this.props.canVisitLocation) return this.props.children

            return <Landing />
        }

        return this.props.children
    }
}

function locationAllowedForNonClanUser(location) {
    return location === LEADERBOARD || location.includes(CHALLENGES)
}

export const mapStateToProps = (state, ownProps) => {
    const { account, clan } = state

    const isAuthenticated = (account.id !== null)
    const hasClan = (clan.id !== null)
    const isNonClanUser = isAuthenticated && !hasClan

    return {
        isNonClanUser,
        canVisitLocation: !isNonClanUser || locationAllowedForNonClanUser(ownProps.location.pathname),
    }
}

export default connect(mapStateToProps)(StrongholdWrapper)



// WEBPACK FOOTER //
// ./containers/StrongholdWrapper/StrongholdWrapper.jsx